var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidIcons095Clear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_95_-_CLEAR",
    "data-name": "95 - CLEAR"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.42,
    y1: 44.44,
    x2: 51.73,
    y2: 44.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 82.86,
    y1: 60,
    x2: 36.17,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.3,
    y1: 75.56,
    x2: 20.6,
    y2: 75.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidIcons095Clear);
export default __webpack_public_path__ + "static/media/hid-icons_095-CLEAR.075c20a3bf04155766ce08fe967b8834.svg";
export { ForwardRef as ReactComponent };